module.exports = __webpack_public_path__ + "img/barber_marker.4b704829.png";